/* Add-to-cart cheer (see snippets/xmas-cart-cheer.liquid).

   Listens for any successful request to /cart/add, whichever button made it
   (product page, quick buy, tea cards, apps), so a failed add (out of stock)
   never gets a cheer. A different maker, message and spot on the screen each
   time. */

(function () {
  if (window.__xmasCheer) return;
  window.__xmasCheer = true;

  var root = document.querySelector('[data-xmas-cheer]');
  if (!root || !window.fetch) return;

  var messages = [];
  try {
    messages = JSON.parse(root.querySelector('[data-xmas-cheer-messages]').textContent);
  } catch (e) {}
  var template = root.querySelector('[data-xmas-cheer-makers]');
  if (!messages.length || !template) return;

  var SHOW_MS = 3200;
  // On phones the cart fills the screen, so skip the bottom spot that would
  // sit over its checkout button
  var SPOTS = window.matchMedia('(max-width: 749px)').matches
    ? ['left', 'left-high', 'top']
    : ['left', 'bottom', 'left-high', 'top'];
  var makers = null;
  var stage = null;
  var bubble = null;
  var lastMaker = -1;
  var lastMessage = -1;
  var lastSpot = -1;
  var hideTimer = null;

  function pick(length, last) {
    if (length < 2) return 0;
    if (last < 0) return Math.floor(Math.random() * length);
    var i = Math.floor(Math.random() * (length - 1));
    return i >= last ? i + 1 : i;
  }

  function build() {
    // Imported into the page document, so the artwork starts loading now
    makers = [].slice.call(document.importNode(template.content, true).querySelectorAll('img'));
    stage = document.createElement('div');
    stage.className = 'xmas-cheer__maker';
    bubble = document.createElement('p');
    bubble.className = 'xmas-cheer__bubble';
    stage.appendChild(bubble);
    root.appendChild(stage);
  }

  function show() {
    if (!makers) build();
    if (!makers.length) return;

    clearTimeout(hideTimer);

    // Jump to the new spot off screen with no transition, then slide in
    lastSpot = pick(SPOTS.length, lastSpot);
    root.classList.add('is-resetting');
    root.classList.remove('is-in');
    root.setAttribute('data-from', SPOTS[lastSpot]);
    void root.offsetWidth;
    root.classList.remove('is-resetting');

    lastMaker = pick(makers.length, lastMaker);
    lastMessage = pick(messages.length, lastMessage);
    var current = stage.querySelector('img');
    if (current) stage.removeChild(current);
    stage.insertBefore(makers[lastMaker], bubble);
    bubble.textContent = messages[lastMessage];

    var go = function () {
      // Two frames so a quick second add replays the entrance
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          root.classList.add('is-in');
          hideTimer = setTimeout(function () {
            root.classList.remove('is-in');
          }, SHOW_MS);
        });
      });
    };
    var img = makers[lastMaker];
    if (img.complete) go();
    else img.onload = img.onerror = function () { img.onload = img.onerror = null; go(); };
  }

  function isCartAdd(input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    return /\/cart\/add(\.js|\.json)?(\?|$)/.test(url);
  }

  var nativeFetch = window.fetch;
  window.fetch = function (input) {
    var request = nativeFetch.apply(this, arguments);
    if (isCartAdd(input)) {
      request.then(function (response) {
        if (response.ok) setTimeout(show, 300);
      }, function () {});
    }
    return request;
  };
})();
